import React from "react"
import PropTypes from "prop-types"

const Appical = ({
    width, height, className, color,
}) => (
    <svg
        className={className}
        width={width}
        height={height}
        viewBox="0 0 56 64"
    >
        <title>Appical</title>
        <path
            d="M105 0L77.005 15.993l.437.25-.442-.252v32.003l27.998 16.004V64L105 64l20.423-11.675 7.577 4.34V15.991l-.002-.001-.01.006L105 0zm0 8.98l20.14 11.511.005-.003v23.018L105 55.018h-.002L84.855 43.506V20.488l.005.003L105 8.981z"
            transform="translate(-655 -196) translate(578 196)"
            fill={color}
            fillRule="nonzero"
            stroke="none"
            strokeWidth={1}
        />
    </svg>
)

Appical.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    className: PropTypes.string,
    color: PropTypes.string,
}

Appical.defaultProps = {
    width: 56,
    height: 64,
    className: "appical",
    color: "#006AFF",
}

export default Appical
